import { Colors } from '../consts/Colors';
import { Scales } from '../consts/Scales';

export default class Chrono extends Phaser.GameObjects.Container {
    constructor(scene, x, y, time, duration) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.time = time;
        this.duration = duration;

        this.timerBack = this.scene.add.image(0, 0, 'chrono').setOrigin(0.5).setScale(0.5);

        let tim = {
            text: this.time,
            config: {
                size: `${36 * Scales.scaleX}px`,
                fontFamily: 'WWF',
                align: 'center',
                color: Colors.Text.DarkBlue,
                backColor: 'transparent',
                origin: { x: 0.5, y: 0.5 },
                width: 800,
            },
        };

        this.timerText = this.scene.createTextElement(
            this.scene.game.data.langue === 'ara' ? 10 : -10,
            0,
            tim
        );
        // console.log('wesh gros',this.timerText)

        // this.backChrono = this.scene.add.rectangle(0, 0, this.timerText.width + 60, this.timerText.height + 30, Colors.Elmt.BleuVert).setOrigin(0.5)
        this.add(this.timerBack);
        this.add(this.timerText);
    }

    startTimer() {
        this.timeLeft = this.duration;

        // Met à jour le texte du timer chaque seconde
        this.timerEvent = this.scene.time.addEvent({
            delay: 1000,
            callback: this.updateTimer,
            callbackScope: this,
            loop: true,
        });
    }
    restartTimer() {
        this.timeLeft = this.duration;

        // Met à jour le texte du timer chaque seconde
        this.timerEvent = this.scene.time.addEvent({
            delay: 1000,
            callback: this.updateTimer,
            callbackScope: this,
            loop: true,
        });
    }

    updateTimer() {
        // Diminue le temps restant
        this.timeLeft--;

        // Calcule les minutes et les secondes restantes
        let minutes = Math.floor(this.timeLeft / 60);
        let seconds = this.timeLeft % 60;

        // Formate le texte du timer
        this.timerText.setText(`${minutes}:${seconds.toString().padStart(2, '0')}`);

        // Si le temps est écoulé, arrête le timer
        if (this.timeLeft <= 0) {
            this.timerEvent.remove();
            this.onTimerComplete();
        }
    }

    onTimerComplete() {
        console.log('Game End');
        this.scene.scene.start('GameEnd');
    }

    stopTimer() {
        this.timerEvent.remove();
    }
}
